/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Google_Drive_TitleInputs */

const en_google_drive_title = /** @type {(inputs: Google_Drive_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Drive`)
};

const es_google_drive_title = /** @type {(inputs: Google_Drive_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Drive`)
};

/**
* | output |
* | --- |
* | "Google Drive" |
*
* @param {Google_Drive_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const google_drive_title = /** @type {((inputs?: Google_Drive_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Google_Drive_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_google_drive_title(inputs)
	return en_google_drive_title(inputs)
});